import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, Newspaper, Radio, Film, Cpu, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Patrimoine congolais",
  title: "Musées universitaires",
  banner_image: "/media/museum-classical.jpg",
  intro:
    "Les cinq musées universitaires de l'UNISIC valorisent la mémoire médiatique, cinématographique, audiovisuelle et technologique de la République Démocratique du Congo. Chaque musée présente ses collections en photos, vidéos, audios et documents.",
};

const MUSEES = [
  { key: "phototheque", to: "phototheque", Icon: Camera, color: "#0A2E52", title: "Photothèque", desc: "Photographies patrimoniales de l'UNISIC et de son environnement médiatique.", banner: "/media/museum-photos.jpg" },
  { key: "presse_ecrite", to: "presse-ecrite", Icon: Newspaper, color: "#D4AF37", title: "Musée de la presse écrite congolaise", desc: "Archives des journaux, hebdomadaires et publications de presse écrite en RDC.", banner: "/media/museum-publications.jpg" },
  { key: "audiovisuel", to: "audiovisuel", Icon: Radio, color: "#144C86", title: "Musée de l'audiovisuel congolais", desc: "Radiodiffusion, télévision, émissions historiques et personnalités.", banner: "/media/museum-events.jpg" },
  { key: "cinema", to: "cinema", Icon: Film, color: "#E63946", title: "Musée du cinéma congolais", desc: "Œuvres, cinéastes, festivals et patrimoine cinématographique du pays.", banner: "/media/hero-university.jpg" },
  { key: "tic", to: "tic", Icon: Cpu, color: "#0F766E", title: "Musée des Technologies de l'Information et de la Communication en RDC", desc: "Évolution du numérique, télécoms et écosystème digital congolais.", banner: "/media/research-lab.jpg" },
];

export default function MuseesUniversitairesHub() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/bm.musees_universitaires").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);
  return (
    <div data-testid="musees-univ-hub">
      <section className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-4xl sm:text-5xl font-bold tracking-tight max-w-4xl">{content.title}</h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="eyebrow eyebrow-dark">Présentation</div>
        <span className="divider-gold mt-3" />
        <p className="mt-6 text-lg text-slate-700 leading-relaxed max-w-4xl whitespace-pre-line">{content.intro}</p>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {MUSEES.map((m) => (
            <Link key={m.key} to={m.to} className="group paper-card card-hover overflow-hidden flex flex-col" data-testid={`musee-univ-card-${m.key}`}>
              <div className="relative h-48 overflow-hidden">
                <img src={m.banner} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm mb-2" style={{ background: m.color, color: "#fff" }}>
                    <m.Icon className="w-5 h-5" />
                  </div>
                  <h3 className="text-white text-lg font-bold mt-1 leading-tight">{m.title}</h3>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <p className="text-sm text-slate-600 flex-1">{m.desc}</p>
                <div className="mt-4 inline-flex items-center gap-2 text-unisic-blue font-semibold text-sm group-hover:text-unisic-gold transition-colors">
                  Visiter <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
